"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var commonweb_utils_1 = require("commonweb-utils");
var addresses_1 = require("../../../actions/addresses");
var constants_1 = require("../../../constants");
var VIEWS = constants_1.default.VIEWS;
var manage_generic_component_1 = require("../../../components/manage-generic.component");
var toast_component_1 = require("../../../components/toast.component");
var modalHeader_1 = require("../../../actions/modalHeader");
/**
 * Manage address component
 */
var ManageAddress = /** @class */ (function (_super) {
    tslib_1.__extends(ManageAddress, _super);
    function ManageAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedAddress: {},
        };
        return _this;
    }
    ManageAddress.prototype.componentDidMount = function () {
        var deviceType = commonweb_utils_1.objectUtils.safeGet(this.props.deviceInfo, "deviceType");
        if (deviceType === "WEBVIEW") {
            this.props.changeHeaderVisibility(false);
        }
    };
    ManageAddress.prototype.sortAddresses = function (addresses) {
        var _this = this;
        var sortedAddresses = addresses.sort(function (item1, item2) {
            return (item2.primary - item1.primary ||
                _this.compareValues(item2, item1) ||
                item2.billing - item1.billing);
        });
        return sortedAddresses;
    };
    // This is for Fraudnet Integration
    ManageAddress.prototype._injectConfig = function () {
        var script = document.getElementById("fconfig");
        if (script) {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        }
        script = document.createElement("script");
        script.id = "fconfig";
        script["type"] = "application/json";
        script.setAttribute("fncls", "fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99");
        var configuration = {
            f: "dede76we-15fd-ak32-a9f4-36ctr35o3a99",
            s: "cmV0dXJuVXJsP-address",
        };
        script["text"] = JSON.stringify(configuration);
        document.body.appendChild(script);
    };
    ManageAddress.prototype.compareValues = function (item1, item2) {
        if (item1.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.ADD) ||
            item1.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.EDIT) ||
            item1.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.ADD_AS_PRIMARY) ||
            item1.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.UPADTE_PRIMARY))
            return 1;
        else if (item2.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.ADD) ||
            item2.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.EDIT) ||
            item2.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.ADD_AS_PRIMARY) ||
            item2.hasOwnProperty(VIEWS.ADDRESSES.TOAST_INTENTS.UPADTE_PRIMARY))
            return -1;
        else
            return 0;
    };
    ManageAddress.prototype.render = function () {
        var content = this.props.content.addresses, pageInfo = this.props.pageInfo.deviceType, commonContent = this.props.content.common, addressObj = this.props.addresses, fptiObj = this.props.fptiObj, form;
        if (this.props.typeOfAction) {
            addressObj = this.sortAddresses(this.props.addresses);
        }
        {
            this._injectConfig();
        }
        form = (React.createElement("form", null,
            this.props.typeOfAction && (React.createElement(toast_component_1.ToastByIntentComponent, { type: this.props.typeOfAction, content: content, fptiObj: fptiObj, viewType: "ADDRESSES", props: this.props, object: addressObj, contentType: "Address" })),
            addressObj && addressObj.length > 0 && (React.createElement(manage_generic_component_1.ManageBodyComponent, { currentObj: this, objTobeRendered: addressObj, type: "ADDRESSES", content: content, commonContent: commonContent, fpti: fptiObj, props: this.props, setSpinner: null }))));
        return React.createElement("div", null, form);
    };
    return ManageAddress;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, fpti = _a.fpti, pageInfo = _a.pageInfo, deviceInfo = _a.deviceInfo;
    var addresses = commonweb_utils_1.objectUtils.safeGet(account, "addressData.addresses") || {};
    var typeOfAction = commonweb_utils_1.objectUtils.safeGet(account, "addressData.typeOfAction") || {};
    var fptiObj = fpti.address;
    return {
        _csrf: _csrf,
        ui: ui,
        route: route,
        content: content,
        addresses: addresses,
        typeOfAction: typeOfAction,
        fptiObj: fptiObj,
        pageInfo: pageInfo,
        showNavigation: modalHeader_1.showNavigation,
        deviceInfo: deviceInfo,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        performedAction: function (typeOfAction) { return dispatch(addresses_1.removeToast(typeOfAction)); },
        changeHeaderVisibility: function (value) { return dispatch(modalHeader_1.showNavigation(value)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ManageAddress);
